/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = [''];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3Zhci93d3cvaHRtbC9NeURlc2lnblYzL2h0bWwvc3JjL2FwcC9mcm9udC9hbmFseXRpY3MtZnJvbnQvYW5hbHl0aWNzLXRvcC11c2VkLXRlbXBsYXRlcy9hbmFseXRpY3MtdG9wLXVzZWQtdGVtcGxhdGVzLmNvbXBvbmVudC5jc3Muc2hpbS5uZ3N0eWxlLnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vdmFyL3d3dy9odG1sL015RGVzaWduVjMvaHRtbC9zcmMvYXBwL2Zyb250L2FuYWx5dGljcy1mcm9udC9hbmFseXRpY3MtdG9wLXVzZWQtdGVtcGxhdGVzL2FuYWx5dGljcy10b3AtdXNlZC10ZW1wbGF0ZXMuY29tcG9uZW50LmNzcyJdLCJzb3VyY2VzQ29udGVudCI6WyIgIl0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7In0=



// WEBPACK FOOTER //
// ./src/$$_gendir/app/front/analytics-front/analytics-top-used-templates/analytics-top-used-templates.component.css.shim.ngstyle.ts